import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getJobOpening, updateJobOpening } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import { states } from "../../utils/dataFile";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import Loader from "../../utils/Loader";

const INIT_STATE = {
    jobTitle: "",
    jobType: "",
    industry: "",
    location: "",
    min_qualification: "",
    experience_length: "",
    job_level:"",
    jobSummary: "",
    jobDescription: "",
    currency: "",
    monthly_salary: "",
    negotiable: "",
    days_online: "",
    available_openings: "",
};

export default function EditJobOpening() {
    const { id } = useParams();
    const history = useHistory();
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);
    const [job, setJobOpening] = useState(null);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        if(id){
            getJobOpening(id)
                .then((res) => {
                    if(res.data.success){
                        setJobOpening(res.data.data);
                    } else {
                        alertError(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.data?.error)
                });
        }
        setLoading(false);
    }, [id]); 

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            jobTitle: (job && job.jobTitle ) || "",
            jobType: (job && job.jobType ) || "",
            industry: (job && job.industry) || "",
            location: (job && job.location) || "",
            jobDescription: (job && job.jobDescription) || "",
            jobSummary: (job && job.jobSummary) || "",
            currency: (job && job.currency) || "",
            monthly_salary: (job && job.monthly_salary) || "",
            negotiable: (job && job.negotiable) || "",
            days_online: (job && job.days_online) || "",
            available_openings: (job && job.available_openings) || "",
            status: (job && job.status) || "",
            min_qualification: (job && job.min_qualification) || "",
            experience_length: (job && job.experience_length) || "",
            job_level: (job && job.job_level) || "",
        }));
    }, [job]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = {
            ...state, id
        };

        if(data.jobType && data.jobSummary && data.jobDescription && data.jobTitle){
            setLoading(true);
            updateJobOpening(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message)
                    setTimeout(() => {
                        history.push('/recruitment/jobs');
                    }, 3500);
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
            })
            .catch((err) => {
                alertError(err.response?.data?.error);
                setLoading(false);
            });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/recruitment/jobs" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Update Job Opening</div>
                        </div>
                        <div className="card-body">
                            {(state && state.jobTitle && state.jobSummary) ? 
                            <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Title: <span>*</span></label>
                                        <input name="jobTitle"  type="text" placeholder="Job Title" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.jobTitle || ""} disabled={loading} />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Type: <span>*</span></label>
                                        <select className="form-control form-select" name="jobType" id="jobType" required  
                                        onChange={handleChange} defaultValue={state.jobType || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value="full-time" selected={state.jobType}>Full-Time</option>
                                            <option value="part-time" selected={state.jobType}>Part-Time</option>
                                            <option value="internship" selected={state.jobType}>Internship and Graduate</option>
                                            <option value="contract" selected={state.jobType}>Contract</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Industry: <span>*</span></label>
                                        <select className="form-control form-select" name="industry" id="industry" required  
                                        onChange={handleChange} defaultValue={state.industry || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value="accounting" selected={state.industry}>Accounting</option>
                                            <option value="administrative-and-office" selected={state.industry}>Administrative and Office</option>
                                            <option value="agriculture-fishing-forestry" selected={state.industry}>Agriculture, Fishing & Forestry</option>
                                            <option value="automotive-aviation" selected={state.industry}>Automotive & Aviation</option>
                                            <option value="advertising-media-communications" selected={state.industry}>Advertising, Media & Communications</option>
                                            <option value="banking-finance-insurance" selected={state.industry}>Banking, Finance & Insurance</option>
                                            <option value="construction" selected={state.industry}>Construction</option>
                                            <option value="consulting" selected={state.industry}>Consulting</option>
                                            <option value="creative-and-design" selected={state.industry}>Creative and Design</option>
                                            <option value="customer-service-and-support" selected={state.industry}>Customer Service and Support</option>
                                            <option value="education" selected={state.industry}>Education</option>
                                            <option value="enforcement-security" selected={state.industry}>Enforcement & Security</option>
                                            <option value="engineering-and-construction" selected={state.industry}>Engineering and Construction</option>
                                            <option value="health-and-safety" selected={state.industry}>Health and Safety</option>
                                            <option value="human-resources" selected={state.industry}>Human Resources</option>
                                            <option value="energy-utilities" selected={state.industry}>Energy & Utilities</option>
                                            <option value="entertainment-events-sport" selected={state.industry}>Entertainment, Events & Sport</option>
                                            <option value="healthcare" selected={state.industry}>Healthcare</option>
                                            <option value="hospitality-hotel" selected={state.industry}>Hospitality & Hotel</option>
                                            <option value="it-telecoms" selected={state.industry}>IT & Telecoms</option>
                                            <option value="law-compliance" selected={state.industry}>Law & Compliance</option>
                                            <option value="manufacturing-warehousing" selected={state.industry}>Manufacturing & Warehousing</option>
                                            <option value="mining-energy-metals" selected={state.industry}>Mining, Energy & Metals</option>
                                            <option value="ngo-npo-charity" selected={state.industry}>NGO, NPO & Charity</option>
                                            <option value="real-estate" selected={state.industry}>Real Estate</option>
                                            <option value="recruitment" selected={state.industry}>Recruitment</option>
                                            <option value="retail-fashion-fmcg" selected={state.industry}>Retail, Fashion & FMCG</option>
                                            <option value="shipping-logistics" selected={state.industry}>Shipping & Logistics</option>
                                            <option value="tourism-travel" selected={state.industry}>Tourism & Travel</option>
                                            <option value="unspecified" selected={state.industry}>Unspecified</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Location: <span>*</span></label>
                                        <select className="form-control form-select" name="location" id="location" required  
                                        onChange={handleChange} defaultValue={state.location || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            {states && states.map((item, i) => (
                                                <option key={i} value={item.value} selected={state.location}>{item.label && item.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Minimum Qualification: <span>*</span></label>
                                        <select className="form-control form-select" name="min_qualification" id="min_qualification" required  
                                        onChange={handleChange} defaultValue={state.min_qualification || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value="ssce" selected={state.min_qualification}>School Certificate (SSCE)</option>
                                            <option value="diploma" selected={state.min_qualification}>National Diploma (OND/HND)</option>
                                            <option value="bachelors" selected={state.min_qualification}>Bachelors Degree</option>
                                            <option value="masters" selected={state.min_qualification}>Masters</option>
                                            <option value="phd" selected={state.min_qualification}>PhD</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Experience Length: <span>*</span></label>
                                        <select className="form-control form-select" name="experience_length" id="experience_length" required  
                                        onChange={handleChange} defaultValue={state.experience_length || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value='1 year' selected={state.experience_length}>1 year</option>
                                            <option value='2 years' selected={state.experience_length}>2 years</option>
                                            <option value='3 years' selected={state.experience_length}>3 years</option>
                                            <option value='4 years' selected={state.experience_length}>4 years</option>
                                            <option value='5 years' selected={state.experience_length}>5 years</option>
                                            <option value='6 years' selected={state.experience_length}>6 years</option>
                                            <option value='7 years' selected={state.experience_length}>7 years</option>
                                            <option value='8 years' selected={state.experience_length}>8 years</option>
                                            <option value='9 years' selected={state.experience_length}>9 years</option>
                                            <option value='10 years' selected={state.experience_length}>10 years</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Level: <span>*</span></label>
                                        <select className="form-control form-select" name="job_level" id="job_level" required  
                                        onChange={handleChange} defaultValue={state.job_level || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value="no-experience" selected={state.job_level}>No Experience</option>
                                            <option value="internship-graduate" selected={state.job_level}>Internship and Graduate</option>
                                            <option value="entry-level" selected={state.job_level}>Entry Level</option>
                                            <option value="mid-level" selected={state.job_level}>Mid Level</option>
                                            <option value="senior-level" selected={state.job_level}>Senior Level</option>
                                            <option value="executive-level" selected={state.job_level}>Executive Level</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Currency: <span>*</span></label>
                                        <select className="form-control form-select" name="currency" id="currency" required  
                                        onChange={handleChange} defaultValue={state.currency || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value="USD" selected={state.currency}>USD</option>
                                            <option value="NGN" selected={state.currency}>NGN</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Monthly Salary (Gross): <span>*</span></label>
                                        <input name="monthly_salary"  type="text" placeholder="Monthly Salary (Gross)" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.monthly_salary || ""} disabled={loading} />
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Is Salary Negotiable?: <span>*</span></label>
                                        <select className="form-control form-select" name="negotiable" id="negotiable" required  
                                        onChange={handleChange} defaultValue={state.negotiable || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value='Yes' selected={state.negotiable}>Yes</option>
                                            <option value='No' selected={state.negotiable}>No</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Days Online: <span>*</span></label>
                                        <select className="form-control form-select" name="days_online" id="days_online" required  
                                        onChange={handleChange} defaultValue={state.days_online || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value='30' selected={state.days_online}>30 days</option>
                                            <option value='45' selected={state.days_online}>45 days</option>
                                            <option value='90' selected={state.days_online}>90 days</option>
                                        </select>
                                    </div>
                                    <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Available Openings: <span>*</span></label>
                                        <select className="form-control form-select" name="available_openings" id="available_openings" required  
                                        onChange={handleChange} defaultValue={state.available_openings || ""} disabled={loading} >
                                            <option value=''>Select...</option>
                                            <option value='1' selected={state.available_openings}>1</option>
                                            <option value='2' selected={state.available_openings}>2</option>
                                            <option value='3' selected={state.available_openings}>3</option>
                                            <option value='4' selected={state.available_openings}>4</option>
                                            <option value='5' selected={state.available_openings}>5</option>
                                            <option value='6' selected={state.available_openings}>6</option>
                                            <option value='7' selected={state.available_openings}>7</option>
                                            <option value='8' selected={state.available_openings}>8</option>
                                            <option value='9' selected={state.available_openings}>9</option>
                                            <option value='10' selected={state.available_openings}>10</option>
                                        </select>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Summary: <span>*</span></label>
                                        <textarea name="jobSummary" cols="33" rows={6} placeholder="Job Summary" className="form-control" required 
                                        onChange={handleChange} defaultValue={state.jobSummary || ""} maxLength={300} disabled={loading} ></textarea>
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                        <label className="control-label">Job Description/Requirements: <span>*</span></label>
                                        <textarea name="jobDescription" cols="33" rows={6} placeholder="Description/Requirements" className="form-control" 
                                            required onChange={handleChange} defaultValue={state.jobDescription || ""} disabled={loading} ></textarea>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button 
                                            type="submit" 
                                            disabled={loading}
                                            className="btn btn-primary" 
                                            onClick={() => handleSubmit}
                                            style={{minWidth: 160}}
                                        >
                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : "UPDATE JOB OPENING" }
                                        </button>
                                    </div>
                                </div>
                            </form> 
                            : <Loader /> }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
